<template>
  <HomeLayout sidebarClasss="sidebar-garden-help" :url_base="url_base" :logo="logo" :sidebar_items="admin_sidebar_items"
    :logout_default_icon="logout_default_icon" :logout_active_icon="logout_active_icon" />
</template>
  
  
<script>
import $ from "jquery";
import HomeLayout from "@/components/HomeLayout/Index.vue";
import { getImgUrl } from "@/utils/helper-functions.js";
export default {
  name: "GardenHelpAdminHome",
  components: { HomeLayout },
  data() {
    return {
      url_base: "garden_help",
      logo: this.getImgUrl("garden-help/Logo.png"),
      admin_sidebar_items: [
        //   {
        //   title: "My Jobs",
        //   url: "jobs/my_jobs",
        //   default_icon: this.getImgUrl("garden-help/my-jobs-icon.png"),
        //   active_icon: this.getImgUrl("garden-help/my-jobs-icon-active.png"),
        // },
        {
          title: "Jobs Table",
          url: "jobs/list_jobs",
          default_icon: this.getImgUrl("garden-help/jobs-icon.png"),
          active_icon: this.getImgUrl("garden-help/jobs-icon-active.png"),
        },
        {
          title: "Jobs Board",
          url: "jobs/jobs_board",
          default_icon: this.getImgUrl("garden-help/jobs-board-icon.png"),
          active_icon: this.getImgUrl("garden-help/jobs-board-icon-active.png"),
        },
        {
          title: "Add New Job",
          url: "jobs/add_job",
          default_icon: this.getImgUrl("garden-help/add-job-icon.png"),
          active_icon: this.getImgUrl("garden-help/add-job-icon-active.png"),
        },
        {
          title: "Customers",
          url: "customers/list",
          default_icon: this.getImgUrl("garden-help/customers-icon.png"),
          active_icon: this.getImgUrl("garden-help/customers-icon-active.png"),
        },
      ],
      logout_default_icon: this.getImgUrl("garden-help/logout-icon.png"),
      logout_active_icon: this.getImgUrl("garden-help/logout-icon-active.png"),
    };
  },
  updated() { },
  mounted() { },

  methods: {
    getImgUrl,
    logout() { },
  },
};
</script>
<style scoped::v-deep >
@import "styles/garden-help-button-styles.css";
@import "styles/garden-help-styles.css";
</style>


// WEBPACK FOOTER //
// src/projects/garden_help/AdminHome.vue